import axios from 'axios'
// import {
//   Message
// } from 'element-ui'
import {
  getCookie
} from '@/util/utils.js'

export const baseURL = '/api'
const Axios = axios.create({
  baseURL: baseURL,
  timeout: 1000000,
  responseType: 'json',
  withCredentials: true, // 是否允许带cookie
  headers: {
    'Content-Type': 'application/json;charset=UTF-8'
  }
})
// POST传参序列化(添加请求拦截器)
Axios.interceptors.request.use(
  config => {
    let token = getCookie('ent_web_token') || ''
    if (token) {
      config.headers['ent_web_token'] = token
    }
    // 在发送请求之前
    if (
      config.method === 'post'
    ) {

    }
    return config
  },
  error => {
    return Promise.reject(error.data)
  }
)

// 返回状态判断(添加响应拦截器)
Axios.interceptors.response.use(
  res => {
    if (res.data.code === 100 || res.data.code === '100') {
      return res.data
    } else {
      // Message.info(res.data.msg || res.data.actionSheet.content)
      // MessageBox.alert(res.data.msg, '提示', {
      //   type: 'info',
      //   confirmButtonText: '确定'
      // })
      return res.data
    }
  },
  error => {
    return Promise.reject(error)
  }
)
// 对axios的实例重新封装成一个plugin ,方便 Vue.use(xxxx)
export default {
  install: function (Vue, Option) {
    Object.defineProperty(Vue.prototype, '$http', {
      value: Axios
    })
  }
}



// WEBPACK FOOTER //
// ./src/server/index.js